<template>
    <div>
    <v-dialog width="600" v-model="internal">
        <v-card outlined class="rounded-lg pa-4">
            <div class="d-flex flex-row justify-end pb-3 align-center">
                <!-- <v-card-title class="font-weight-bold py-2 px-1"> Operation Details</v-card-title> -->
                <v-btn  icon data-testid="aml-close" @click="closeModal">
                    <v-icon >mdi-close</v-icon>
                </v-btn>
            </div>
            <v-card outlined class="py-3 px-5 rounded-lg info-card">
                <div class="d-flex flex-row justify-space-between align-center">
                   <div class="d-flex flex-row align-center flex-gap-4">
                        <div class="subtle-color">ID: {{ selectedOp.id }}</div>
                       <v-chip outlined x-small :color="amlCheck(selectedOp)"
                           data-testid="aml-approve"
                           :style="{ cursor: (isPartner || selectedOp.amlCheck ? 'default' : 'pointer') }"
                           @click="!isPartner && !selectedOp.amlCheck ? openAmlConfirm(selectedOp.id) : null">
                            <v-icon class="mr-2" :color="amlCheck(selectedOp)" x-small>
                                {{ !selectedOp.amlCheck ? "mdi-alert" : "mdi-check" }}
                            </v-icon>
                            <!-- amlCheck arrives as a boolean or as the string "true" depending on
                                 which path approved the operation, so read it for truth rather than
                                 comparing it to a literal. -->
                            <span style="font-size:.6rem !important;" :style="{ color: amlCheck(selectedOp) }">
                                {{ !selectedOp.amlCheck ? $t('instructions.amlCheck') : $t('instructions.amlApproved') }}
                            </span>
                        </v-chip>
                    </div>

                    <div>
                        <v-btn v-if="!isPartner" data-testid="aml-resend" :disabled="!!selectedOp.amlCheck || isLoading" :loading="isLoading" @click='resendApprovalLink(selectedOp)' color="primary"
                            small>
                            <v-icon class="mx-1" x-small>mdi-email-outline</v-icon>{{  $t('instructions.resendEmail') }}
                        </v-btn>
                    </div>
                </div>

                <div class="d-flex flex-column align-start">
                    <v-card-subtitle class="px-0 pb-1 pt-0  title-card">{{ selectedOp.alias }}</v-card-subtitle>
                    <div v-if="false" class="d-flex align-center pa-0 ma-0">
                        <!-- <v-card-subtitle class="pa-0  title-card green--text">R$ {{ formatPrice(selectedOp?.volumeBrl) }} </v-card-subtitle> -->
                    </div>
                </div>

                <div class="d-flex flex-row align-center flex-gap-4">

                    <div>
                        <v-icon x-small class="mx-1">mdi-tag-outline</v-icon>
                        <v-chip color="black" class="black-chip" small outlined>
                            {{ formatOperationTypeTitle(selectedOp.operationType) }}
                        </v-chip>
                    </div>

                    <div class="subtle-color">
                        <v-icon x-small class="mx-1">mdi-domain</v-icon>{{ selectedOp.companyName }}
                    </div>

                    <div class="subtle-color">
                        <v-icon x-small class="mx-1">mdi-file-outline</v-icon>{{ selectedOp.length }} docs uploaded
                    </div>
                </div>
            </v-card>

        </v-card>
    </v-dialog>

    <v-dialog
        v-model="inputDialog"
        persistent
        max-width="500"
        overlay-opacity="0.59"
    >
        <v-card class="pa-5">
            <div class="text-h6 mb-4">
                {{ $t('broker.dialogs.actionClient1') }}
            </div>
            <h4>
                {{ $t('broker.dialogs.deleteClient2') }}
            </h4>

            <div class="d-flex justify-end">
                <v-btn text @click="inputDialog = false">{{ $t('instructions.cancel') }}</v-btn>
                <v-btn color="primary" data-testid="aml-approve-confirm" @click="confirmAmlCheck">{{ $t('instructions.confirm') }}</v-btn>
            </div>
        </v-card>
    </v-dialog>
    </div>
</template>

<script>
import { useExecutionStore, useInteractionEmailStore, useSnackbarStore } from '@/store';
import { mapActions, mapStores } from 'pinia';
import { formatPrice } from '@/utils';

export default {
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        selectedOp: {
            type: Object,
        },
        masterEmail: {
            type: String,
            default: '',
        },
        brokerEmail: {
            type: String,
            default: '',
        },
    },
    mounted(){
        this.isPartner = localStorage.getItem('userRole') === 'partner'
    },
    data() {
        return {
            isPartner: null,
            amlCheckedId: null,
            inputDialog: false,
            isLoading: false,
            mocked: { "id": "4779e5e0c7894db6a6ecfe217aeb159c", "rfqId": null, "brokerId": "f561da7a9cfcd0e0449d79ed1ec0058b92d26611", "companyId": "250e9071c34655a1b11d70e4e247e9806f702702", "alias": "erwrwer", "amlCheck": true, "length": 1, "qty": null, "ccy": null, "status": null, "side": null, "operationType": "paymentGoodsServicesEfx", "companyName": "cliente" }
        }
    },
    computed: {
        internal: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit("input", v);
            },
        },
        ...mapStores(useExecutionStore),
        ...mapStores(useInteractionEmailStore)
    },
    methods: {
        ...mapActions(useSnackbarStore,[
            "open"
        ]),
        formatPrice (price) {
            return price ? formatPrice(formatPrice(price)) : ''
        },
        amlCheck(op) {
            return op.amlCheck ? '#00c853' : '#ff6d00'
        },
        openAmlConfirm(id) {
            this.amlCheckedId = id
            this.inputDialog = true
        },
        async confirmAmlCheck() {
            if (!this.amlCheckedId) return
            this.isLoading = true;

            try {
                await this.executionStore.updateAmlCheck(this.amlCheckedId, true)
                this.inputDialog = false
                this.amlCheckedId = null
                if (this.selectedOp) this.selectedOp.amlCheck = true
                this.open(this.$t('instructions.amlApprovedSnackbar'))
            } catch (err) {
                this.open(this.$t('instructions.amlApprovedError'))
                console.error("Error approving AML check:", err)
            } finally {
                this.isLoading = false
            }
        },
        closeModal() {
            this.internal = false;
        },
        formatOperationTypeTitle(type) {
            const label = String(this.$t('broker.operationTypes')?.[type] || type || '-')
            return label
        },
        async resendApprovalLink(op) {
            this.isLoading = true;

            try {
                await this.interactionEmailStore.requestOperationApproval({
                    operationId: op.id,
                    brokerId: op.brokerId
                })
                this.open(this.$t('instructions.emailResent'))
            } catch (error) {
                console.error("Error resending email:", error)
                this.open(this.$t('instructions.emailResendError'), 'error')
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>

<style scoped>
.info-card {
    display: flex;
    flex-direction: column;
    gap: .9rem;
    background-color: #2b2b2b87;
}

.subtle-color {
    color: rgb(168, 168, 168);
}

.v-chip.v-size--small,
.v-btn.v-size--small {
    height: 21px;
}

::v-deep.v-chip.v-chip--outlined.v-chip.v-chip.black-chip {
    background: #1E1E1E !important;
    border: 1px solid #3d3d3d !important;
    color: white !important;
}
::v-deep.title-card{
    font-weight: bold;
    font-size: 1rem;
}
</style>